import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import type { AnswerRow, OwnListRow } from "@shared/plan-home/own-list";

export type OwnList = { rows: OwnListRow[]; counts: { live: number; done: number; open: number }; answers?: AnswerRow[] };

/** s232 (PLAN-HOME-1 PR 2) — the one list for the plan's home: the rows that show and their Done / Skip (server-computed
 *  by shared/plan-home/own-list.ts). The progress bar and the needs panel both read it. */
export function ownListKey(clientId: string) {
  return ["/api/clients", clientId, "own-list"] as const;
}

export function useOwnList(clientId: string) {
  return useQuery<OwnList>({
    queryKey: ownListKey(clientId),
    queryFn: async () => (await apiRequest("GET", `/api/clients/${clientId}/own-list`)).json(),
    enabled: !!clientId,
  });
}
